import type { EvidenceUploadMode, ModelResults } from 'api';

import type { AnalysisStatus } from '../../types';
import { getAnalysisStatusUsingBaleModel } from './getAnalysisStatusUsingBaleModel';
import { getAnalysisStatusUsingGradeService } from './getAnalysisStatusUsingGradeService';

export const getAnalysisStatus = (
  mode: EvidenceUploadMode,
  model_results: ModelResults,
  useGradeService: boolean
): AnalysisStatus => {
  return useGradeService
    ? getAnalysisStatusUsingGradeService(model_results, mode)
    : getAnalysisStatusUsingBaleModel(model_results, mode);
};
